import React, { useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { getHorizontalScrollWidgetId } from '../../../utils';

export const ModalButton = ({ onClick, onScroll }) => {
  useEffect(() => {
    window.addEventListener('click', onClick);

    // Monitorizamos el scroll del horizontal-scroll que tenga por encima (si hay) para poder ajustar la posicion de dropdown
    const scrollContainerWidget = document.querySelector(
      'atres-widget[data-type=horizontal-scroll]'
    );
    let scrollContainer;
    if (scrollContainerWidget) {
      const { id } = scrollContainerWidget;
      if (id) {
        scrollContainer = document.getElementById(
          getHorizontalScrollWidgetId(id)
        );
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', onScroll);
        }
      }
    }
    return () => {
      window.removeEventListener('click', onClick);
      if (scrollContainer) {
        window.removeEventListener('scroll', onScroll);
      }
    };
  }, [onClick, onScroll]);

  return '';
};

ModalButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  id: PropTypes.string.isRequired
};

ModalButton.defaultProps = { onScroll: undefined };

export const ModalContactButton = props => {
  const hide = useCallback(() => {
    const dropdown = document.querySelector('div.Contacts');
    if (dropdown) {
      dropdown.style.display = 'none';
    }
    const modal = document.querySelector('div.ProgramHeader-modal');
    if (modal) {
      modal.classList.remove('show');
    }
  }, []);

  const show = useCallback(() => {
    const dropdown = document.querySelector('div.Contacts');
    if (dropdown) {
      dropdown.style.display = 'block';
    }
    const modal = document.querySelector('div.ProgramHeader-modal');
    if (modal) {
      modal.classList.add('show');
    }
  }, []);

  const handleClick = useCallback(
    e => {
      if (
        e.target.parentElement &&
        e.target.parentElement.classList.contains('contactBtn')
      ) {
        show();
      } else {
        hide();
      }
    },
    [show, hide]
  );

  const onScroll = useRef(
    debounce(() => {
      hide();
    }, 300)
  ).current;

  return <ModalButton {...props} onClick={handleClick} onScroll={onScroll} />;
};

export const ModalRSSButton = props => {
  const show = useCallback(() => {
    const dropdown = document.querySelector('div.Contacts_rss');
    if (dropdown) {
      dropdown.style.display = 'block';
    }
    const modal = document.querySelector('div.ProgramHeader-modal_rss');
    if (modal) {
      modal.classList.add('show');
    }
  }, []);

  const hide = useCallback(() => {
    const dropdown = document.querySelector('div.Contacts_rss');
    if (dropdown) {
      dropdown.style.display = 'none';
    }
    const modal = document.querySelector('div.ProgramHeader-modal_rss');
    if (modal) {
      modal.classList.remove('show');
    }
  }, []);

  const handleClick = useCallback(
    e => {
      if (
        e.target.parentElement &&
        e.target.parentElement.classList.contains('item-menu_rss')
      ) {
        show();
      } else {
        hide();
      }
    },
    [show, hide]
  );

  const onScroll = useRef(
    debounce(() => {
      hide();
    }, 300)
  ).current;

  return <ModalButton {...props} onClick={handleClick} onScroll={onScroll} />;
};
